import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExercisesComponent } from './exercises/exercises.component';
import { TopicRoutingModule } from './topic-routing.module';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { BinarySearchComponent } from './binary-search/binary-search.component';
import { BinaryComponent } from './binary/binary.component';
import { TBinarySearchComponent } from './t-binary-search/t-binary-search.component';
import { TBinaryComponent } from './t-binary/t-binary.component';
import { BinaryInsertComponent } from './binary-insert/binary-insert.component';
import { TBinaryInsertComponent } from './t-binary-insert/t-binary-insert.component';
import { HashElementComponent } from './hash-element/hash-element.component';
import { HashComponent } from './hash/hash.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { THashComponent } from './t-hash/t-hash.component';
import { THashElementComponent } from './t-hash-element/t-hash-element.component';
import { FindHashComponent } from './find-hash/find-hash.component';
import { TFindHashComponent } from './t-find-hash/t-find-hash.component';
import { TestHashComponent } from './test-hash/test-hash.component';
import { TTestHashComponent } from './t-test-hash/t-test-hash.component';
import { PlaygroundComponent } from './playground/playground.component';
import { ArrayLengthNotLargerDirective } from './array-length-not-larger.directive';
import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    NgbModule,
    NgxChartsModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    TExercisesComponent,
    TAllExercisesComponent,
    ExamComponent,
    EvaluationComponent,
    OpenQuestionComponent,
    TOpenQuestionComponent,
    TExamComponent,
    TAllExamsComponent,
    MultipleChoiceComponent,
    TMultipleChoiceComponent,
    BinarySearchComponent,
    TBinarySearchComponent,
    TBinaryComponent, 
    BinaryInsertComponent, 
    TBinaryInsertComponent, 
    HashElementComponent, 
    THashComponent, 
    THashElementComponent, 
    FindHashComponent, 
    TFindHashComponent, 
    TestHashComponent,
     TTestHashComponent, 
     PlaygroundComponent, 
     ArrayLengthNotLargerDirective, 
     ExampleComponent, 
     TExampleComponent]

})
export class SearchAndOrderModule { }
export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}